function getDefaultValue(value) {
  return value;
}

export { getDefaultValue };
//# sourceMappingURL=get-default-value.js.map
